export default __webpack_public_path__ + "static/media/icons8-double-tick-96.ec5ae934.svg";